import React, {ReactNode} from "react";

interface PageLayoutProps {
    children: ReactNode;
}

export const PageLayout: React.FC<PageLayoutProps> = ({children}) => {
    return (
        <div className="page-layout flex flex-col h-full">
            {children}
        </div>
    );
};
